/**************************************************
 * Nombre:       Formulario_Programa_PerfilEmpre
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjetas_Informacion from "../../Tarjeta/Tarjetas_Informacion";
import Formulario_Programa_Perfil_Perfil from "./Formulario_Programa_Perfil_Perfil";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import Formulario_Programa_PerfilEmpre_Lideres from "./Formulario_Programa_PerfilEmpre_Lideres";
import Tarjetas_Lideres from "../../Tarjeta/Tarjetas_Lideres";

const Formulario_Programa_PerfilEmpre = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Lider',
        dato: 'lideres',
        Tarjeta: Tarjetas_Lideres,
        Formulario: Formulario_Programa_PerfilEmpre_Lideres,
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={8} nombre={'Perfil de emprendimiento'}
                                  dato={'perfilEmpre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Agregar Lideres destacados</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Programa_PerfilEmpre